import React from "react";
import { Link } from "react-router-dom";
import InstallButton from "../components/InstallButton";

export default function Landing() {
  return (
    <div data-testid="landing-page" className="min-h-[calc(100vh-80px)] sunrise-bg">
      {/* HERO */}
      <section className="relative max-w-6xl mx-auto px-6 sm:px-10 pt-24 sm:pt-36 pb-32 reveal">
        <h1 className="serif text-5xl sm:text-7xl lg:text-[88px] leading-[1.02] tracking-tight text-foreground max-w-5xl">
          The same truth,
          <br />
          <em className="text-[hsl(var(--primary))] font-light not-italic">spoken</em> in different tongues.
        </h1>
        <p className="mt-12 max-w-2xl text-lg leading-relaxed text-foreground/75">
          An archive that places teachings from religion, philosophy, esoteric tradition, hidden history, and
          declassified record side by side — so we may meet the evolution Earth and humanity are now passing
          through with the only instruments that work: <span className="text-[hsl(var(--primary))]">empathy</span>,
          <span className="text-[hsl(var(--primary))]"> love</span>, and
          <span className="text-[hsl(var(--primary))]"> truth</span>.
        </p>
        <p className="mt-6 max-w-2xl serif italic text-xl text-[hsl(var(--accent))]/90">
          Wherever you begin, you arrive somewhere. Be curious. Be unafraid. The thread will hold.
        </p>
        <div className="mt-14 flex flex-wrap items-center gap-6">
          <Link to="/traditions" data-testid="cta-enter-archive" className="btn-gold">Enter the Archive</Link>
          <InstallButton className="btn-ghost" label="Get the app" />
        </div>
      </section>

      {/* MANIFESTO — the Cor·relate reveal */}
      <section className="max-w-3xl mx-auto px-6 sm:px-10 py-32">
        <div className="label mb-10 text-[hsl(var(--accent))] text-center">Why this is called Correlate</div>
        <div className="space-y-6 text-center">
          <p className="serif text-3xl sm:text-4xl text-foreground">
            <span className="text-[hsl(var(--primary))]">Cor</span>
            <span className="text-muted-foreground/60"> — </span>
            <span className="italic text-foreground">Latin for heart, and the root of core.</span>
          </p>
          <p className="serif text-3xl sm:text-4xl text-foreground">
            <span className="text-foreground">Relate</span>
            <span className="text-muted-foreground/60"> — </span>
            <span className="italic text-foreground">to bring something back, to tell it, to connect it.</span>
          </p>
          <p className="serif text-3xl sm:text-4xl text-foreground pt-4">
            <span className="text-[hsl(var(--primary))]">Cor</span>
            <span className="text-muted-foreground/75">·</span>
            <span className="text-foreground">relate</span>
            <span className="text-muted-foreground/60"> — </span>
            <span className="italic text-foreground">to carry the heart of a truth across to another truth.</span>
          </p>
          <p className="serif italic text-xl text-[hsl(var(--accent))] pt-6">That is the work of this archive.</p>
        </div>
      </section>

      {/* THE NOTE */}
      <section className="max-w-3xl mx-auto px-6 sm:px-10 pb-32 text-center">
        <div className="label mb-8 text-[hsl(var(--accent))]">A Note from the Archivists</div>
        <p className="serif italic text-2xl sm:text-3xl text-foreground leading-snug">
          &ldquo;Something is happening to us — and to the Earth — that our separate vocabularies were never
          large enough to hold alone. The Logos is the Tao. The Tao is the Aum. The Dark Night is the
          Nigredo. We do not invent the correlations — we restore them, so the passage may be met
          with empathy, love, and truth.&rdquo;
        </p>
        <p className="mt-10 serif text-lg text-muted-foreground italic">
          Be curious. Be unafraid. You are not the first to feel this.
        </p>
        <div className="label mt-8">— Correlate</div>
      </section>
    </div>
  );
}
